<template>
    <section>
        <h3 id="about-fiber-popin-title">
            {{ dto.title }}
        </h3>

        <nav class="ob1-menu-page ob1-menu-page-fullscreen mb-1" style="height: auto !important;">
            <ul class="nav ob1-nav-light">
                <li id="nav-advantages" class="nav-item active">
                    <button
                        class="nav-link"
                        aria-current="page"
                        data-fiber-popin-tab="pills-advantages"
                    >
                        <span class="d-block d-sm-none without-click">{{ dto.advantagesNavMobile }}</span>
                        <span class="d-none d-sm-block without-click">{{ dto.advantagesNavDesktop }}</span>
                    </button>
                </li>
                <li id="nav-steps" class="nav-item">
                    <button
                        class="nav-link"
                        data-fiber-popin-tab="pills-steps"
                    >
                        <span class="d-block d-sm-none without-click">{{ dto.stepsNavMobile }}</span>
                        <span class="d-none d-sm-block without-click">{{ dto.stepsNavDesktop }}</span>
                    </button>
                </li>
            </ul>
        </nav>
        <div id="pills-tabContent" class="tab-content tab-content-clear pt-0" style="border: 0 !important;">
            <div id="pills-advantages">
                <div class="row">
                    <div class="col-12 px-0">
                        <ul class="items-list row">
                            <li v-for="advantage in dto.advantages" class="col-12">
                                <div class="items-list-item">
                                    <span
                                        class="item-icon mb-2"
                                        :class="advantage.picto"
                                        aria-hidden="true"
                                    />
                                    <div class="item-container mb-2">
                                        <div class="item-text">
                                            <span>
                                                {{ advantage.title }}
                                            </span>
                                            <small class="item-desc">
                                                {{ advantage.text }}
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div id="pills-steps" hidden>
                <div class="row">
                    <div class="col-12 px-0">
                        <p class="text-mw pb-2">
                            {{ dto.stepsIntro }}
                        </p>
                        <div v-for="(step, index) in dto.steps" class="d-flex pb-1">
                            <div class="flex-shrink-0">
                                <picture class="align-self-start me-2">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="34"
                                        height="34"
                                        viewBox="0 0 34 34"
                                    >
                                        <g fill="none" fill-rule="evenodd">
                                            <circle
                                                cx="17"
                                                cy="17"
                                                r="16.5"
                                                fill="#FFF"
                                                fill-rule="nonzero"
                                                stroke="#000"
                                            />
                                            <text
                                                fill="#000"
                                                font-family="HelveticaNeue-Roman, Helvetica Neue"
                                                font-size="16"
                                            >
                                                <tspan x="12.552" y="23">{{ index + 1 }}</tspan>
                                            </text>
                                        </g>
                                    </svg>
                                </picture>
                            </div>
                            <div class="flex-grow-1 ms-1">
                                <p class="lead mb-0">
                                    <strong>{{ step.title }}</strong>
                                </p>
                                <p class="m-0" v-html="step.textHtml" />
                            </div>
                        </div>
                        <div class="alert-container alert-info" role="alert">
                            <p class="alert">
                                <span class="alert-icon" aria-hidden="true" />
                                <span class="ob1-alert-title">{{ dto.stepsInsertTitle }}</span>
                            </p>
                            <div class="alert-content step-insert-text">
                                <p class="text-mw pb-0 mb-0" v-html="dto.stepInsertTextHtml" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import {manageFiberPopin} from "../../../../../../../common/eligibility/fragments/FiberPopin.module";

export default {
    name: "FiberPopin",
    props: {
        dto: {type: Object, required: true}
    },
    mounted() {
        manageFiberPopin();
    },
}
</script>

<style scoped lang="scss">

.without-click {
    pointer-events: none;
}

</style>
